import { Tab } from "../types/Tab";
import TabDropdown from "./TabDropdown";
import TabDropdownSkeleton from "./TabDropdownSkeleton";
import { useCatalog } from "../contexts/CatalogContext";

const TabDropdownList = () => {
  const { getDomains, getChildCategories, isCategoriesLoading } = useCatalog();

  return (
    <>
      <TabDropdown tab={Tab.Home} />

      {/* The shop tabs come from Square, so on a cold visit there's a beat
          where the nav has no shopping entry point at all. Hold the slot with
          a placeholder rather than letting the tab pop in and shove the rest
          of the nav sideways. */}
      {isCategoriesLoading && <TabDropdownSkeleton />}

      {getDomains()
        // TODO: Eventually put these back in
        ?.filter((d) => getChildCategories(d.id)?.length > 0)
        ?.sort((a, b) => {
          const aChildren = getChildCategories(a.id)?.length;
          const bChildren = getChildCategories(b.id)?.length;
          return aChildren - bChildren;
        })
        ?.map((d, i) => <TabDropdown key={i} domain={d} />)}

      <TabDropdown tab={Tab.Orders} />
      <TabDropdown tab={Tab.About} />
      <TabDropdown tab={Tab.Contact} />
    </>
  );
};

export default TabDropdownList;
